'use client';

import { useNuqsNextAppRouterAdapter } from '../chunk-S37JZELB.js';
import { useNuqsNextPagesRouterAdapter, isPagesRouter } from '../chunk-6OWCDW4K.js';
import '../chunk-QHW6KBHR.js';
import '../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../chunk-DASHEO2X.js';

// src/adapters/next.ts
function useNuqsNextAdapter() {
  const pagesRouterImpl = useNuqsNextPagesRouterAdapter();
  const appRouterImpl = useNuqsNextAppRouterAdapter();
  return {
    searchParams: appRouterImpl.searchParams,
    updateUrl(search, options) {
      if (isPagesRouter()) {
        return pagesRouterImpl.updateUrl(search, options);
      } else {
        return appRouterImpl.updateUrl(search, options);
      }
    }
  };
}
var NuqsAdapter = createAdapterProvider(useNuqsNextAdapter);

export { NuqsAdapter };
